import { Calendar } from "lucide-react";

const POSTS = [
  {
    tag: "Tax",
    date: "Nov 2025",
    title: "The Quiet Power of Roth Conversions in a Rate-Pause Year",
    excerpt: "Why the window between peak earning years and Required Minimum Distributions is the most tax-efficient era of most retirement plans — and how to use it.",
  },
  {
    tag: "Retirement",
    date: "Oct 2025",
    title: "Sequencing Withdrawals: The 60/20/20 Framework",
    excerpt: "A simple rule for which buckets to draw from first — and the rare cases where the textbook order is exactly the wrong answer.",
  },
  {
    tag: "Estate",
    date: "Sep 2025",
    title: "Why Most Beneficiary Designations Don't Match the Will",
    excerpt: "An audit of 200 client households revealed a 38% misalignment between beneficiary forms and estate documents. Here is the five-minute fix.",
  },
  {
    tag: "Markets",
    date: "Aug 2025",
    title: "The Concentrated Stock Problem (and Three Ways Through It)",
    excerpt: "If 30% or more of your net worth sits in one ticker, time is rarely your friend. A practical, tax-aware diversification playbook.",
  },
];

export default function InsightsPage() {
  return (
    <div data-testid="page-insights" className="bg-[#F9F8F6]">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Insights</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0F292F] font-light tracking-tight max-w-3xl leading-[1.05]">
          Plain-English notes on tax & related topics.
        </h1>
        <p className="mt-6 text-sm text-[#52525B] max-w-2xl leading-relaxed">
          The articles below are educational only and are not personalized tax, legal, or investment
          advice. They should not be relied upon as a recommendation. Please consult an appropriately
          licensed professional regarding your situation.
        </p>
      </section>

      <div className="hairline max-w-7xl mx-auto" />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-2 gap-px bg-black/10 border border-black/10">
        {POSTS.map((p, i) => (
          <article
            key={p.title}
            data-testid={`insight-${i}`}
            className="bg-white p-10 md:p-12 hover:bg-[#F3F1EC] transition-colors duration-500 group cursor-pointer"
          >
            <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] mb-6">
              <span className="text-[#8E6A2B]">{p.tag}</span>
              <span className="w-6 h-px bg-black/20" />
              <span className="text-[#52525B] flex items-center gap-2"><Calendar size={12} />{p.date}</span>
            </div>
            <h3 className="font-serif text-3xl md:text-4xl text-[#0F292F] mb-5 leading-tight group-hover:text-[#8E6A2B] transition-colors">
              {p.title}
            </h3>
            <p className="text-[#52525B] leading-relaxed">{p.excerpt}</p>
            <div className="mt-8 text-xs uppercase tracking-[0.2em] text-[#0F292F] inline-flex items-center gap-2">
              Read article →
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
